<template>
  <div class="grid-container">
    <section-header size="xl" variants="dividing" class="mt-3">
      <div>
        <heading level="1" size="xl" v-html="bp('title')"></heading>
      </div>
    </section-header>
    <p class="mb-2" v-html="bp('description')"></p>
    <div class="max-w-sm mb-3">
      <pdl-callout v-if="message" :kind="messageType">
        <template #content>
          <span v-html="message" />
        </template>
      </pdl-callout>
      <form id="forgottenPwdForm" action="#" autocomplete="off" :class="{'opacity-50': isWorking}" @submit="submit">
        <form-group
          id="forgottenPwd.email"
          v-model="email"
          v-validate="'required|email'"
          name="email"
          type="email"
          :data-vv-as="bp('label')"
          :show-error-messages="true"
          :error="errors.first('email')"
          :label="bp('label')"
        />
        <div class="buttons">
          <trek-button primary type="submit" :disabled="isWorking" @click="submit">
            <span v-html="bp('submit')"></span>
          </trek-button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import get from 'lodash/get';
import TrekButton from '@/components/TrekButton';
import {PdlCallout} from '@pedal/pdl-callout';
import {UserAccountBase} from '@/components/containers/my-account/utils/user-account-base';

export default {
  components: {TrekButton, PdlCallout},
  extends: UserAccountBase,
  data() {
    return {
      email: '',
    };
  },
  methods: {
    /**
     * Process request.
     */
    async processUpdate() {
      this.isWorking = true;
      try {
        const response = await this.api.passwordRecovery({
          email: this.email,
          CSRFToken: this.options.CSRFToken,
        });

        const isError = get(response.data.meta, 'feedback.type') !== 'success';
        const message = get(response.data.meta, 'feedback.message.basePropertyValue');

        if (isError) {
          this.displayError(message);
        } else {
          this.resetForm();
        }
      } catch (e) {
        this.displayError(e.message);
      } finally {
        this.isWorking = false;
      }
    },

    /**
     * Reset form data to defaults.
     */
    resetForm() {
      this.email = '';
    },
  },
};
</script>
